export default __webpack_public_path__ + "static/media/tramitta-logo-white.9c88a817.png";